export default "__VITE_ASSET__a9c2be29__"